// import React, { useEffect, useState } from 'react';
// import { Modal, DatePicker, Space, Spin, Descriptions, Button } from 'antd';
// import { ELETRICITY_OPERATORS, ELETRICITY_VIEW_BILL2, ELETRICITY_BILL_PAYMENT2 } from '../../Utils/appConstants';
// import { getRequest, postRequest } from '../../Utils/AppApi';
// import { useHistory } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'antd/dist/antd.css';
// import moment from 'moment';
// import Select from 'react-select';

// function ElectricityBillPayment(props) {
//   const dateFormat = 'DD/MM/YYYY';
//   const queryDateFormat = 'YYYY-MM-DD';
//   const history = useHistory();

//   const [isModalViewBill, setIsModalViewBill] = useState(false);
//   const [formData, setFormData] = useState({
//     operator: '',
//     accountNumber: '',
//     mobileUnitCycle: '',
//     processingCycle: '',
//     dueDate: '',
//     customerMobile: '',
//     amount: '',
//   });
//   const [formErrors, setFormErrors] = useState({});
//   const [operators, setOperators] = useState([]);
//   const [customerInfo, setCustomerInfo] = useState(null);
//   const [commissionData, setCommissionData] = useState(null);
//   const [paymentId, setPaymentId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paymentLoading, setPaymentLoading] = useState(false);

//   const [mobileUnitCycleLabel, setMobileUnitCycleLabel] = useState('Cycle / Unit / Mobile');
//   const [processingCycleLabel, setProcessingCycleLabel] = useState('Processing Cycle');
//   const [showMobileUnitCycle, setShowMobileUnitCycle] = useState(false);
//   const [showProcessingCycle, setShowProcessingCycle] = useState(false);

//   useEffect(() => {
//     const fetchOperators = async () => {
//       try {
//         const response = await getRequest(ELETRICITY_OPERATORS, history);
//         if (response.success) {
//           setOperators(
//             response.data
//               .filter((item) =>
//                 item.ind_code !== null &&
//                 item.ind_code !== undefined &&
//                 item.ind_code !== ""
//               )
//               .map((item) => ({
//                 value: item.code,
//                 label: item.name,
//                 field1: item.field1,
//                 field2: item.field2,
//                 appCode: item.appCode,
//                 indCode: item.ind_code,
//               }))
//           );
//         } else {
//           toast.error(response.message);
//         }
//       } catch (error) {
//         toast.error('Failed to fetch operators');
//       }
//     };
//     fetchOperators();
//   }, [history]);

//   const clearForm = () => {
//     setFormData({
//       operator: '',
//       accountNumber: '',
//       mobileUnitCycle: '',
//       processingCycle: '',
//       dueDate: '',
//       customerMobile: '',
//       amount: '',
//     });
//     setFormErrors({});
//     setPaymentId(null);
//     setCustomerInfo(null);
//     setCommissionData(null);
//     setMobileUnitCycleLabel('Cycle / Unit / Mobile');
//     setProcessingCycleLabel('Processing Cycle');
//     setShowMobileUnitCycle(false);
//     setShowProcessingCycle(false);
//   };

//   const handleOperatorChange = (selectedOption) => {
//     const field1 = selectedOption?.field1;
//     const field2 = selectedOption?.field2;
//     setMobileUnitCycleLabel(field1 || 'Cycle / Unit / Mobile');
//     setProcessingCycleLabel(field2 || 'Processing Cycle');
//     setShowMobileUnitCycle(!!field1);
//     setShowProcessingCycle(!!field2);
//     setFormData((prev) => ({ ...prev, operator: selectedOption?.value || '', mobileUnitCycle: '', processingCycle: '' }));
//     setFormErrors((prev) => ({ ...prev, operator: false, mobileUnitCycle: false, processingCycle: false }));
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'mobileUnitCycle' && mobileUnitCycleLabel === 'Mobile Number' && value && !/^\d{0,10}$/.test(value)) {
//       return;
//     }
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setFormErrors((prev) => ({ ...prev, [name]: false }));
//   };

//   const handleDateChange = (date) => {
//     const dateValue = date ? moment(date).format(queryDateFormat) : '';
//     setFormData((prev) => ({ ...prev, dueDate: dateValue }));
//     setFormErrors((prev) => ({ ...prev, dueDate: false }));
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.operator) errors.operator = true;
//     if (!formData.accountNumber) errors.accountNumber = true;
//     if (showMobileUnitCycle && !formData.mobileUnitCycle) errors.mobileUnitCycle = true;
//     if (showProcessingCycle && !formData.processingCycle) errors.processingCycle = true;
//     if (!formData.dueDate) errors.dueDate = true;
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const viewBill = async () => {
//     if (!validateForm()) return;
//     setLoading(true);
//     try {
//       const selectedOperator = operators.find((opt) => opt.value === formData.operator);
//       const payload = {
//         provider: selectedOperator?.indCode || formData.operator,
//         accountNumber: formData.accountNumber,
//         mobileUnitCycle: formData.mobileUnitCycle,
//         billDueDate: formData.dueDate,
//         mobile: formData.customerMobile,
//         field1: selectedOperator?.field1 || null,
//         field2: selectedOperator?.field2 || null,
//         appCode: selectedOperator?.appCode || null,
//         code: formData.operator,
//         field1Value: showMobileUnitCycle ? formData.mobileUnitCycle : null,
//         field2Value: showProcessingCycle ? formData.processingCycle : null,
//       };
//       if (formData.operator === 'JBVNL') {
//         payload.divcode = formData.mobileUnitCycle;
//       }
//       const response = await postRequest(ELETRICITY_VIEW_BILL2, payload, history);
//       if (response.success && response.data?.billAmount) {
//         setCustomerInfo(response.data);
//         setCommissionData(response.commissionData);
//         setPaymentId(response.id);
//         setFormData((prev) => ({ ...prev, amount: response.data.billAmount }));
//         setIsModalViewBill(true);
//       } else {
//         toast.error(response.message || 'Invalid bill data');
//       }
//     } catch (error) {
//       toast.error('Failed to fetch bill details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const billPayment = async () => {
//     if (!formData.amount || parseFloat(formData.amount) < 200) {
//       toast.error('Bill amount must be greater than 200 to proceed with payment');
//       return;
//     }

//     setPaymentLoading(true);
//     try {
//       const selectedOperator = operators.find((opt) => opt.value === formData.operator);
//       const payload = {
//         provider: formData.operator,
//         paymentId,
//         amount: formData.amount,
//         field1: selectedOperator?.field1 || null,
//         field2: selectedOperator?.field2 || null,
//         appCode: selectedOperator?.appCode || null,
//         code: formData.operator,
//         field1Value: showMobileUnitCycle ? formData.mobileUnitCycle : null,
//         field2Value: showProcessingCycle ? formData.processingCycle : null,
//         accountNumber: formData.accountNumber || null,
//       };
//       const response = await postRequest(ELETRICITY_BILL_PAYMENT2, payload, history);
//       if (response.success) {
//         toast.success(response.message || 'Electricity bill paid successfully');
//         setIsModalViewBill(false);
//         clearForm();
//       } else {
//         toast.error(response.message || 'Payment failed');
//       }
//     } catch (error) {
//       toast.error('Payment failed: ' + (error.message || 'An error occurred'));
//     } finally {
//       setPaymentLoading(false);
//     }
//   };

//   const handleHideModal = () => {
//     setIsModalViewBill(false);
//     clearForm();
//   };

//   return (
//     <div>
//       {loading && (
//         <div className="parentDisable" style={{ width: '100%' }}>
//           <Space direction="vertical" style={{ width: '100%' }}>
//             <Spin tip="Loading" size="large">
//               <div className="spin-loader" />
//             </Spin>
//           </Space>
//         </div>
//       )}
//       <div className="pt-4">
//         <h4 className="mb-3 fa-1x">Electricity Bill Payment</h4>
//         <div className="form-group">
//           <Select
//             options={operators}
//             className={`normal-light w-100 ${formErrors.operator ? 'is-invalid' : ''}`}
//             classNamePrefix="select"
//             onChange={handleOperatorChange}
//             placeholder="Select Your Electricity Provider"
//             value={operators.find((opt) => opt.value === formData.operator) || null}
//             aria-label="Electricity Provider"
//           />
//           {formErrors.operator && <span className="error text-danger">This field is required</span>}
//         </div>
//         <div className="form-group">
//           <input
//             type="text"
//             className={`form-control normal-light ${formErrors.accountNumber ? 'is-invalid' : ''}`}
//             placeholder="Enter Consumer Account (CA) Number"
//             name="accountNumber"
//             value={formData.accountNumber}
//             maxLength={30}
//             onChange={handleInputChange}
//             aria-label="Consumer Account Number"
//           />
//           {formErrors.accountNumber && <span className="error text-danger">This field is required</span>}
//         </div>
//         {showMobileUnitCycle && (
//           <div className="form-group">
//             <input
//               type="text"
//               className={`form-control normal-light ${formErrors.mobileUnitCycle ? 'is-invalid' : ''}`}
//               placeholder={mobileUnitCycleLabel}
//               name="mobileUnitCycle"
//               value={formData.mobileUnitCycle}
//               maxLength={mobileUnitCycleLabel === 'Mobile Number' ? 10 : 30}
//               onChange={handleInputChange}
//               aria-label={mobileUnitCycleLabel}
//             />
//             {formErrors.mobileUnitCycle && <span className="error text-danger">{mobileUnitCycleLabel} is required</span>}
//           </div>
//         )}
//         {showProcessingCycle && (
//           <div className="form-group">
//             <input
//               type="text"
//               className={`form-control normal-light ${formErrors.processingCycle ? 'is-invalid' : ''}`}
//               placeholder={processingCycleLabel}
//               name="processingCycle"
//               value={formData.processingCycle}
//               maxLength={30}
//               onChange={handleInputChange}
//               aria-label={processingCycleLabel}
//             />
//             {formErrors.processingCycle && <span className="error text-danger">{processingCycleLabel} is required</span>}
//           </div>
//         )}
//         <div className="form-group">
//           <DatePicker
//             format={dateFormat}
//             className={`form-control normal-light ${formErrors.dueDate ? 'is-invalid' : ''}`}
//             placeholder="Select Due Date"
//             value={formData.dueDate ? moment(formData.dueDate, queryDateFormat) : null}
//             onChange={handleDateChange}
//             aria-label="Due Date"
//           />
//           {formErrors.dueDate && <span className="error text-danger">This field is required</span>}
//         </div>
//         <div className="form-group">
//           <input
//             type="text"
//             className="form-control normal-light"
//             placeholder="Customer Mobile (Optional)"
//             name="customerMobile"
//             value={formData.customerMobile}
//             maxLength={10}
//             onChange={handleInputChange}
//             aria-label="Customer Mobile"
//           />
//         </div>
//         <div className="row pt-2">
//           <div className="col-12">
//             <button
//               type="button"
//               className="btn btn-danger mb-2 btn-block"
//               onClick={viewBill}
//               disabled={loading}
//             >
//               View Bill
//             </button>
//           </div>
//         </div>
//       </div>
//       <ToastContainer
//         position="top-center"
//         autoClose={5000}
//         limit={2}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//       />

//       {isModalViewBill && (
//         <Modal
//           title="Customer Bill Details"
//           width={540}
//           open={isModalViewBill}
//           onCancel={handleHideModal}
//           centered
//           footer={[
//             <Button
//               key="cancel"
//               size="large"
//               onClick={handleHideModal}
//               style={{ marginRight: '32px', minWidth: '120px' }}
//             >
//               Cancel
//             </Button>,
//             <Button
//               key="submit"
//               type="primary"
//               size="large"
//               loading={paymentLoading}
//               disabled={!formData.amount || parseFloat(formData.amount) <= 0}
//               onClick={billPayment}
//               style={{
//                 minWidth: '160px',
//                 backgroundColor: '#C9262C',
//                 borderColor: '#C9262C',
//                 color: '#FFDD09'   // Yellow text on red button
//               }}
//             >
//               {paymentLoading ? 'Processing...' : `Pay ₹${customerInfo?.billAmount || '0'}`}
//             </Button>
//           ]}
//         >
//           {paymentLoading ? (
//             <div style={{ textAlign: 'center', padding: '40px 0' }}>
//               <Spin tip="Processing Payment..." size="large" />
//             </div>
//           ) : customerInfo ? (
//             <div style={{ padding: '8px 0' }}>
//               <Descriptions bordered column={1} size="small">
//                 <Descriptions.Item label="Customer Name">
//                   <strong>{customerInfo.name || 'N/A'}</strong>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Bill Date">
//                   {customerInfo.billDate || 'N/A'}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Due Date">
//                   {customerInfo.billDueDate || 'N/A'}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Bill Amount">
//                   <span style={{
//                     fontSize: '18px',
//                     fontWeight: '600',
//                     color: '#C9262C'
//                   }}>
//                     ₹{customerInfo.billAmount || '0'}
//                   </span>
//                 </Descriptions.Item>
//               </Descriptions>

//               <div style={{ marginTop: 20 }}>
//                 <h5 style={{
//                   marginBottom: 10,
//                   color: '#C9262C'
//                 }}>
//                   Commissions
//                 </h5>
//                 <Descriptions bordered column={1} size="small">
//                   <Descriptions.Item label="Service Amount">
//                     ₹{Number(commissionData?.serviceAmount || 0).toFixed(2)}
//                   </Descriptions.Item>
//                   <Descriptions.Item label="Commission Amount">
//                     ₹{Number(commissionData?.commissionAmount || 0).toFixed(2)}
//                   </Descriptions.Item>
//                   <Descriptions.Item label="TDS Amount">
//                     ₹{Number(commissionData?.tdsAmount || 0).toFixed(2)}
//                   </Descriptions.Item>
//                 </Descriptions>
//               </div>

//               <div style={{
//                 background: '#FFF9E6',
//                 border: '1px solid #FFDD09',
//                 borderRadius: '6px',
//                 padding: '12px',
//                 marginTop: 20,
//                 fontSize: '14px'
//               }}>
//                 <ul style={{ paddingLeft: '18px', margin: '0' }}>
//                   <li>Payment will be reflect in 12 working hours</li>
//                   <li>Same Day due Date Payment not allowed</li>
//                 </ul>
//               </div>
//             </div>
//           ) : (
//             <p style={{ textAlign: 'center', padding: '30px 0' }}>No customer information available.</p>
//           )}
//         </Modal>
//       )}
//     </div>
//   );
// }

// export default ElectricityBillPayment;


import React, { useEffect, useState } from 'react';
import { Modal, DatePicker, Space, Spin, Descriptions, Button } from 'antd';
import { ELETRICITY_OPERATORS, ELETRICITY_VIEW_BILL2, ELETRICITY_BILL_PAYMENT2 } from '../../Utils/appConstants';
import { getRequest, postRequest } from '../../Utils/AppApi';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'antd/dist/antd.css';
import moment from 'moment';
import Select from 'react-select';

function ElectricityBillPayment(props) {
  const dateFormat = 'DD/MM/YYYY';
  const queryDateFormat = 'YYYY-MM-DD';
  const history = useHistory();

  const [isModalViewBill, setIsModalViewBill] = useState(false);
  const [formData, setFormData] = useState({
    operator: '',
    accountNumber: '',
    mobileUnitCycle: '',
    processingCycle: '',
    dueDate: '',
    customerMobile: '',
    amount: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [operators, setOperators] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [commissionData, setCommissionData] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);

  const [mobileUnitCycleLabel, setMobileUnitCycleLabel] = useState('Cycle / Unit / Mobile');
  const [processingCycleLabel, setProcessingCycleLabel] = useState('Processing Cycle');
  const [showMobileUnitCycle, setShowMobileUnitCycle] = useState(false);
  const [showProcessingCycle, setShowProcessingCycle] = useState(false);
  // Tracks whether the selected operator already asks for a mobile number
  const [operatorAsksForMobile, setOperatorAsksForMobile] = useState(false);

  useEffect(() => {
    const fetchOperators = async () => {
      try {
        const response = await getRequest(ELETRICITY_OPERATORS, history);
        if (response.success) {
          setOperators(
            response.data
              .filter((item) =>
                item.ind_code !== null &&
                item.ind_code !== undefined &&
                item.ind_code !== ""
              )
              .map((item) => ({
                value: item.code,
                label: item.name,
                field1: item.field1,
                field2: item.field2,
                appCode: item.appCode,
                indCode: item.ind_code,
              }))
          );
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error('Failed to fetch operators');
      }
    };
    fetchOperators();
  }, [history]);

  const clearForm = () => {
    setFormData({
      operator: '',
      accountNumber: '',
      mobileUnitCycle: '',
      processingCycle: '',
      dueDate: '',
      customerMobile: '',
      amount: '',
    });
    setFormErrors({});
    setPaymentId(null);
    setCustomerInfo(null);
    setCommissionData(null);
    setMobileUnitCycleLabel('Cycle / Unit / Mobile');
    setProcessingCycleLabel('Processing Cycle');
    setShowMobileUnitCycle(false);
    setShowProcessingCycle(false);
    setOperatorAsksForMobile(false);
  };

  const handleOperatorChange = (selectedOption) => {
    const field1 = selectedOption?.field1;
    const field2 = selectedOption?.field2;
    const isMobile = field1 && field1.toLowerCase().includes('mobile');
    setOperatorAsksForMobile(!!isMobile);
    setMobileUnitCycleLabel(field1 || 'Cycle / Unit / Mobile');
    setProcessingCycleLabel(field2 || 'Processing Cycle');
    setShowMobileUnitCycle(!!field1);
    setShowProcessingCycle(!!field2);
    setFormData((prev) => ({ ...prev, operator: selectedOption?.value || '', mobileUnitCycle: '', processingCycle: '' }));
    setFormErrors((prev) => ({ ...prev, operator: false, mobileUnitCycle: false, processingCycle: false }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mobileUnitCycle' && mobileUnitCycleLabel === 'Mobile Number' && value && !/^\d{0,10}$/.test(value)) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleDateChange = (date) => {
    const dateValue = date ? moment(date).format(queryDateFormat) : '';
    setFormData((prev) => ({ ...prev, dueDate: dateValue }));
    setFormErrors((prev) => ({ ...prev, dueDate: false }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.operator) errors.operator = true;
    if (!formData.accountNumber) errors.accountNumber = true;

    // If the operator provides a mobile field, it becomes mandatory and must be valid
    if (showMobileUnitCycle && !formData.mobileUnitCycle) errors.mobileUnitCycle = true;
    if (operatorAsksForMobile && formData.mobileUnitCycle && !/^\d{10}$/.test(formData.mobileUnitCycle)) {
      errors.mobileUnitCycle = true;
    }

    if (showProcessingCycle && !formData.processingCycle) errors.processingCycle = true;
    if (!formData.dueDate) errors.dueDate = true;

    // Customer mobile is mandatory only when the operator does NOT already ask for it
    if (!operatorAsksForMobile) {
      if (!formData.customerMobile) {
        errors.customerMobile = true;
      } else if (!/^\d{10}$/.test(formData.customerMobile)) {
        errors.customerMobile = true;
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const viewBill = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      const selectedOperator = operators.find((opt) => opt.value === formData.operator);
      const payload = {
        provider: selectedOperator?.indCode || formData.operator,
        accountNumber: formData.accountNumber,
        mobileUnitCycle: formData.mobileUnitCycle,
        billDueDate: formData.dueDate,
        // Use the operator's mobile field if it asks for one, otherwise use the separate customer mobile
        mobile: operatorAsksForMobile ? formData.mobileUnitCycle : formData.customerMobile,
        field1: selectedOperator?.field1 || null,
        field2: selectedOperator?.field2 || null,
        appCode: selectedOperator?.appCode || null,
        code: formData.operator,
        field1Value: showMobileUnitCycle ? formData.mobileUnitCycle : null,
        field2Value: showProcessingCycle ? formData.processingCycle : null,
      };
      if (formData.operator === 'JBVNL') {
        payload.divcode = formData.mobileUnitCycle;
      }
      const response = await postRequest(ELETRICITY_VIEW_BILL2, payload, history);
      if (response.success && response.data?.billAmount) {
        setCustomerInfo(response.data);
        setCommissionData(response.commissionData);
        setPaymentId(response.id);
        setFormData((prev) => ({ ...prev, amount: response.data.billAmount }));
        setIsModalViewBill(true);
      } else {
        toast.error(response.message || 'Invalid bill data');
      }
    } catch (error) {
      toast.error('Failed to fetch bill details');
    } finally {
      setLoading(false);
    }
  };

  const billPayment = async () => {
    if (!formData.amount || parseFloat(formData.amount) < 200) {
      toast.error('Bill amount must be greater than 200 to proceed with payment');
      return;
    }

    setPaymentLoading(true);
    try {
      const selectedOperator = operators.find((opt) => opt.value === formData.operator);
      const payload = {
        provider: formData.operator,
        paymentId,
        amount: formData.amount,
        field1: selectedOperator?.field1 || null,
        field2: selectedOperator?.field2 || null,
        appCode: selectedOperator?.appCode || null,
        code: formData.operator,
        field1Value: showMobileUnitCycle ? formData.mobileUnitCycle : null,
        field2Value: showProcessingCycle ? formData.processingCycle : null,
        accountNumber: formData.accountNumber || null,
      };
      const response = await postRequest(ELETRICITY_BILL_PAYMENT2, payload, history);
      if (response.success) {
        toast.success(response.message || 'Electricity bill paid successfully');
        setIsModalViewBill(false);
        clearForm();
      } else {
        toast.error(response.message || 'Payment failed');
      }
    } catch (error) {
      toast.error('Payment failed: ' + (error.message || 'An error occurred'));
    } finally {
      setPaymentLoading(false);
    }
  };

  const handleHideModal = () => {
    setIsModalViewBill(false);
    clearForm();
  };

  return (
    <div>
      {loading && (
        <div className="parentDisable" style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Spin tip="Loading" size="large">
              <div className="spin-loader" />
            </Spin>
          </Space>
        </div>
      )}
      <div className="pt-4">
        <h4 className="mb-3 fa-1x">Electricity Bill Payment</h4>
        <div className="form-group">
          <Select
            options={operators}
            className={`normal-light w-100 ${formErrors.operator ? 'is-invalid' : ''}`}
            classNamePrefix="select"
            onChange={handleOperatorChange}
            placeholder="Select Your Electricity Provider"
            value={operators.find((opt) => opt.value === formData.operator) || null}
            aria-label="Electricity Provider"
          />
          {formErrors.operator && <span className="error text-danger">This field is required</span>}
        </div>
        <div className="form-group">
          <input
            type="text"
            className={`form-control normal-light ${formErrors.accountNumber ? 'is-invalid' : ''}`}
            placeholder="Enter Consumer Account (CA) Number"
            name="accountNumber"
            value={formData.accountNumber}
            maxLength={30}
            onChange={handleInputChange}
            aria-label="Consumer Account Number"
          />
          {formErrors.accountNumber && <span className="error text-danger">This field is required</span>}
        </div>
        {showMobileUnitCycle && (
          <div className="form-group">
            <input
              type="text"
              className={`form-control normal-light ${formErrors.mobileUnitCycle ? 'is-invalid' : ''}`}
              placeholder={mobileUnitCycleLabel}
              name="mobileUnitCycle"
              value={formData.mobileUnitCycle}
              maxLength={mobileUnitCycleLabel === 'Mobile Number' ? 10 : 30}
              onChange={handleInputChange}
              aria-label={mobileUnitCycleLabel}
            />
            {formErrors.mobileUnitCycle && (
              <span className="error text-danger">
                {operatorAsksForMobile
                  ? 'Valid 10-digit mobile number is required'
                  : `${mobileUnitCycleLabel} is required`}
              </span>
            )}
          </div>
        )}
        {showProcessingCycle && (
          <div className="form-group">
            <input
              type="text"
              className={`form-control normal-light ${formErrors.processingCycle ? 'is-invalid' : ''}`}
              placeholder={processingCycleLabel}
              name="processingCycle"
              value={formData.processingCycle}
              maxLength={30}
              onChange={handleInputChange}
              aria-label={processingCycleLabel}
            />
            {formErrors.processingCycle && <span className="error text-danger">{processingCycleLabel} is required</span>}
          </div>
        )}
        <div className="form-group">
          <DatePicker
            format={dateFormat}
            className={`form-control normal-light ${formErrors.dueDate ? 'is-invalid' : ''}`}
            placeholder="Select Due Date"
            value={formData.dueDate ? moment(formData.dueDate, queryDateFormat) : null}
            onChange={handleDateChange}
            aria-label="Due Date"
          />
          {formErrors.dueDate && <span className="error text-danger">This field is required</span>}
        </div>
        {!operatorAsksForMobile && (
          <div className="form-group">
            <input
              type="text"
              className={`form-control normal-light ${formErrors.customerMobile ? 'is-invalid' : ''}`}
              placeholder="Customer Mobile"
              name="customerMobile"
              value={formData.customerMobile}
              maxLength={10}
              onChange={handleInputChange}
              aria-label="Customer Mobile"
            />
            {formErrors.customerMobile && (
              <span className="error text-danger">Valid 10-digit mobile number is required</span>
            )}
          </div>
        )}
        <div className="row pt-2">
          <div className="col-12">
            <button
              type="button"
              className="btn btn-danger mb-2 btn-block"
              onClick={viewBill}
              disabled={loading}
            >
              View Bill
            </button>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        limit={2}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isModalViewBill && (
        <Modal
          title="Customer Bill Details"
          width={540}
          open={isModalViewBill}
          onCancel={handleHideModal}
          centered
          footer={[
            <Button
              key="cancel"
              size="large"
              onClick={handleHideModal}
              style={{ marginRight: '32px', minWidth: '120px' }}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              size="large"
              loading={paymentLoading}
              disabled={!formData.amount || parseFloat(formData.amount) <= 0}
              onClick={billPayment}
              style={{
                minWidth: '160px',
                backgroundColor: '#C9262C',
                borderColor: '#C9262C',
                color: '#FFDD09'   // Yellow text on red button
              }}
            >
              {paymentLoading ? 'Processing...' : `Pay ₹${customerInfo?.billAmount || '0'}`}
            </Button>
          ]}
        >
          {paymentLoading ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <Spin tip="Processing Payment..." size="large" />
            </div>
          ) : customerInfo ? (
            <div style={{ padding: '8px 0' }}>
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Customer Name">
                  <strong>{customerInfo.name || 'N/A'}</strong>
                </Descriptions.Item>
                <Descriptions.Item label="Bill Date">
                  {customerInfo.billDate || 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item label="Due Date">
                  {customerInfo.billDueDate || 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item label="Bill Amount">
                  <span style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#C9262C'
                  }}>
                    ₹{customerInfo.billAmount || '0'}
                  </span>
                </Descriptions.Item>
              </Descriptions>

              <div style={{ marginTop: 20 }}>
                <h5 style={{
                  marginBottom: 10,
                  color: '#C9262C'
                }}>
                  Commissions
                </h5>
                <Descriptions bordered column={1} size="small">
                  <Descriptions.Item label="Service Amount">
                    ₹{Number(commissionData?.serviceAmount || 0).toFixed(2)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Commission Amount">
                    ₹{Number(commissionData?.commissionAmount || 0).toFixed(2)}
                  </Descriptions.Item>
                  <Descriptions.Item label="TDS Amount">
                    ₹{Number(commissionData?.tdsAmount || 0).toFixed(2)}
                  </Descriptions.Item>
                </Descriptions>
              </div>

              <div style={{
                background: '#FFF9E6',
                border: '1px solid #FFDD09',
                borderRadius: '6px',
                padding: '12px',
                marginTop: 20,
                fontSize: '14px'
              }}>
                <ul style={{ paddingLeft: '18px', margin: '0' }}>
                  <li>Payment will be reflect in 12 working hours</li>
                  <li>Same Day due Date Payment not allowed</li>
                </ul>
              </div>
            </div>
          ) : (
            <p style={{ textAlign: 'center', padding: '30px 0' }}>No customer information available.</p>
          )}
        </Modal>
      )}
    </div>
  );
}

export default ElectricityBillPayment;